import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import Fireplace from "../subparts/fireplace/fireplace";
import Furniture from "../subparts/globals/furniture";

export default class FireplaceParent extends Part {
  static id = 'Fireplace';
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Fireplace';
    this.translateId = "visualizer.fireplace.fireplace";
    this.categoryEnabled = false;
  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Fireplace":
      case "Fierplace":
        relatedItemName = "fireplace";
        RelatedItemClass = Fireplace;
        break;
      case "Furniture": {
        relatedItemName = "furniture";
        RelatedItemClass = Furniture;
        break;
      }
      default:
        break;
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        this.relatedItems.push(this[relatedItemName]);
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  navigationItem() {
    return new DesignNavigationItem("Fireplace", this);
  }

  isSubTypeWithItems() {
    return false;
  }

  handleSubPartClick() {

  }

}
